export default __webpack_public_path__ + "static/vision4Mobile-a893264447af6ba5a55a3c326b7e58c3.png";